import styled from 'styled-components';

export const SplashContainerStyled = styled.div`
  height: calc(100vh - 120px);
  display: flex;
  justify-content: center;
  align-items: center;
  .logo {
  }
`;
